import React from 'react'
import { FormattedMessage } from 'react-intl'

import { PackageAlert } from './PackageAlert'

export type ForcingTakeAwayAlertProps = {
  itemName: string
}

export const ForcingTakeAwayAlert = ({
  itemName,
}: ForcingTakeAwayAlertProps) => (
  <PackageAlert>
    <FormattedMessage
      id="checkout.shipping.select-shipping-method.force-take-away-alert"
      values={{ itemName }}
    />
  </PackageAlert>
)
